export default "__VITE_ASSET__OzrClbwb__"